import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';
import { useWagonContext } from '../../../../contexts/wagonContext/wagonContext';
import { useBooking } from '../../../../contexts/ticketBookingContext/TicketBookingContext';
import filterAvailableSeats from '../../../../../utils/functions/booking/filterAvailableSeats';
import CoupeReserve from '../../../components/CoupeReserve';

function FirstFloor({
  seats, chosenSeats, setChosenSeats, wagonNumber, unReserveSeat, reserveSeat,
}) {
  const { direction } = useWagonContext();
  const { bookingData } = useBooking();
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div
          className="seats-row left "
          style={{ width: '755.3px', marginLeft: '40px' }}
        />
        <div
          className="seats-row bottom left"
          style={{ width: '755.3px', marginLeft: '94px' }}
        >
          <WagonToilet />
          {
              [
                [18, 17], [16, 15], [14, 13], [12, 11], [10, 9], [8, 7], [6, 5], [4, 3], [2, 1],
              ].map((seatsPair) => {
                const availableSeats = filterAvailableSeats({
                  seatsToReserve: seatsPair,
                  direction,
                  seats,
                  bookingData,
                  chosenSeats,
                  reserveSeat,
                  unReserveSeat,
                  wagonNumber,
                });

                return (
                  <React.Fragment key={seatsPair[0]}>
                    <div className="seat-column relative">
                      <CoupeReserve
                        reserveSeat={reserveSeat}
                        unReserveSeat={unReserveSeat}
                        wagonNumber={wagonNumber}
                        availableSeats={availableSeats}
                        seats={seats}
                      />
                      <div className="border border-solid w-[1px] h-[110px] bottom-[-15px] absolute left-1" />
                      <Seat
                        seat={seats?.[seatsPair[0]]}
                        chosenSeats={chosenSeats}
                        setChosenSeats={setChosenSeats}
                        wagonNumber={wagonNumber}
                        reserveSeat={reserveSeat}
                        unReserveSeat={unReserveSeat}
                        compartmentClassName="double"
                        bottom
                        noDirection
                        hidePrice
                      />
                    </div>
                    <div className="relative">
                      <div className="seat-column reversed">
                        <Seat
                          seat={seats?.[seatsPair[1]]}
                          chosenSeats={chosenSeats}
                          setChosenSeats={setChosenSeats}
                          wagonNumber={wagonNumber}
                          reserveSeat={reserveSeat}
                          unReserveSeat={unReserveSeat}
                          compartmentClassName="double"
                          bottom
                          noDirection
                          hidePrice
                        />
                      </div>
                      <div className="border border-solid w-[1px] h-[110px] bottom-[-15px] absolute right-1" />
                    </div>

                  </React.Fragment>
                );
              })
          }
          <WagonDoor />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
